export class AdminDetail {
    email: string;
    first_name: string;
    last_name: string;
    phone_mobile: string;
}
